import React, { useState } from 'react'
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

export default function ContactMe() {
    const form = useRef();
    const [isLoading, setIsLoading] = useState(false);

    const handleForm = e => {
        e.preventDefault();
        setIsLoading(true);

        emailjs.sendForm('service_c3yeaf5', 'template_6b253v6', form.current, 'qtOiIpZ3J0WebEA6j')
            .then((result) => {
                console.log(result.text);
                alert('Form submitted successfully.')
                console.log(e.target.form)
                setIsLoading(false);
                e.target.user_name.value = ''
                e.target.user_phone.value = ''
                e.target.user_email.value = ''
                e.target.message.value = ''
            }, (error) => {
                console.log(error.text);
                setIsLoading(false)
            });

    }
    return (
        <div className='mx-12 my-20 '>
            <div className='flex justify-center gap-2 items-center mb-8 md:mb-16'>
                <div className=' w-12 h-0.5 bg-white'></div>
                <h3 className=' text-white font-bold lg:text-3xl md:text-2xl text-lg text-center'>Contact Me</h3>
                <div className=' w-12 h-0.5 bg-white'></div>
            </div>            <div className='mt-4' id='contact-me'>
                <form ref={form} onSubmit={handleForm} className='md:mx-40'>
                    <div className=' flex flex-col md:flex-row justify-between'>
                        <input required={true} name='user_name' type="text" placeholder='Your name' className='p-4 w-full rounded-lg border-2' />
                        <input name='user_phone' type="number" placeholder='Contact Number' className='p-4 w-full rounded-lg border-2 md:ml-4 mt-4 md:mt-0' />
                    </div>
                    <input required={true} name='user_email' type="email" placeholder='Your email' className='p-4 w-full rounded-lg border-2 mt-4' />
                    <textarea required={true} name="message" cols="20" rows="5" placeholder='Description' className='w-full mt-4 border rounded-lg p-4'></textarea>
                    {
                        isLoading ? <div className=' flex justify-center'>
                            <button className='border px-6 py-4 rounded-lg mt-4 shadow-lg shadow-white hover:text-green-500 uppercase font-bold text-white'>Sending...</button>
                        </div> :
                            <div className=' flex justify-center'>
                                <button type='submit' className='border px-6 py-4 rounded-lg mt-4 shadow-lg shadow-white hover:text-green-500 uppercase font-bold text-white'>Submit</button>
                            </div>
                    }
                </form>
            </div>
        </div>
    )
}
